import { render, staticRenderFns } from "./ReasoningPanel.vue?vue&type=template&id=6619b428&scoped=true"
import script from "./ReasoningPanel.vue?vue&type=script&lang=ts"
export * from "./ReasoningPanel.vue?vue&type=script&lang=ts"
import style0 from "./ReasoningPanel.vue?vue&type=style&index=0&id=6619b428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6619b428",
  null
  
)

export default component.exports